import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../../styled/constants';
import {
  HeaderBackButton,
  HeaderCloseButton,
  HeaderLeftAction,
  HeaderTitleWrapper
} from '../../../../ui/PageHeader/styled';
import { tagStyles } from '../../../../ui/Typography/styles';
import { ellipsisText } from '../../../../../styled/common';

export const ModalContent = styled.div`
  padding: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
  }
`;

export const modalHeaderStyles = (isInputModal: boolean) => css`
  ${HeaderLeftAction} {
    right: 0;
  }

  ${isInputModal &&
  css`
    padding: 0 60px 0 40px;

    @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
      h3 {
        ${ellipsisText};
      }

      ${HeaderTitleWrapper} {
        width: 100%;
      }
    }
  `};

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 30px;
    height: 75px;

    span {
      ${tagStyles.header_bold};
    }

    ${isInputModal &&
    css`
      padding-left: 60px;
    `};

    ${HeaderCloseButton} {
      padding: 0;
    }

    ${HeaderLeftAction} {
      right: 30px;
      width: 35px;
    }
  }
`;

export const modalStyles = css`
  border-radius: 7px 7px 0 0;
  padding-bottom: env(safe-area-inset-bottom);
  height: max-content;
  align-self: end;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 10px 40px;
    align-self: center;
    height: max-content;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 700px;
  }
`;

export const ReportBackButton = styled(HeaderBackButton)`
  left: 6px;
  width: 30px;
  cursor: pointer;
  padding: 0;

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 35px;
    left: 15px;
  }

  &::after {
    border-color: ${({ theme }) => theme.colors.text.primary};
    margin-left: 9px;

    @media (min-width: ${Breakpoints.tablet}px) {
      margin-left: 13px;
    }
  }
`;
